'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tasksApolloClient = exports.apolloClient = undefined;

var _apolloClient = require('apollo-client');

var _apolloCacheInmemory = require('apollo-cache-inmemory');

var _apolloLinkContext = require('apollo-link-context');

var _apolloLinkHttp = require('apollo-link-http');

var _unfetch = require('unfetch');

var _unfetch2 = _interopRequireDefault(_unfetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var ngrokConfig = '0211cfacfc48.ngrok.io';
var cache = new _apolloCacheInmemory.InMemoryCache();
var httpLink = new _apolloLinkHttp.HttpLink({
    uri: "https://" + ngrokConfig + "/workflow/graphql",
    credentials: 'same-origin',
    fetch: _unfetch2.default
});
var tasksHttpLink = new _apolloLinkHttp.HttpLink({
    uri: "https://" + ngrokConfig + "/tasks/graphql",
    credentials: 'same-origin',
    fetch: _unfetch2.default
});
var authLink = (0, _apolloLinkContext.setContext)(function (_, _a) {
    var headers = _a.headers;
    return {
        headers: __assign({}, headers, { 'Access-Control-Allow-Origin': '*' })
    };
});
var apolloClient = exports.apolloClient = new _apolloClient.ApolloClient({
    link: authLink.concat(httpLink),
    cache: cache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'ignore'
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'none'
        },
        mutate: {
            errorPolicy: 'none'
        }
    }
});
var tasksApolloClient = exports.tasksApolloClient = new _apolloClient.ApolloClient({
    link: authLink.concat(tasksHttpLink),
    cache: cache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'ignore'
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'none'
        },
        mutate: {
            errorPolicy: 'none'
        }
    }
});
//# sourceMappingURL=apolloClient.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/config/apolloClient.js
// module id = 963
// module chunks = 0